import { FetchAnalyticsGraphProps, analyticsApi } from "@src/service/analytics";
import { OrderGraphModelMapper } from "../../domain/mapper/OrderGraphMapper";
import { OrderGraphsModel } from "../../domain/model/GraphConfig";

export const fetchAnalyticsGraphRepo = {
  async execute(props: FetchAnalyticsGraphProps): Promise<OrderGraphsModel> {
    const response = await analyticsApi.fetchGraph(props);

    return OrderGraphModelMapper.execute(response);
  },
};
